<template>
</template>
<script>
    export default {
        data() {
            let vm = this;
            return {
                element: null,
                resources: {
                    zIndex: {
                        name: 'zIndex',
                        defaultValue: '',
                        labelDesc: 'zIndex',
                        callback: function () {
                            vm.resources.zIndex.defaultValue = this.value;
                            vm.element.internal_config.zIndex = this.value;

                        },
                    },

                    textLogin: {
                        name: 'textLogin',
                        defaultValue: '',
                        labelDesc: 'text-login',
                        canRemove: false,
                        callback: function () {
                            vm.resources.textLogin.defaultValue = this.value.trim();
                            vm.element.internal_config.textLogin = this.value.trim();
                        },
                    },

                    // textRegister: {
                    // 	name: 'textRegister',
                    // 	defaultValue: '',
                    // 	labelDesc: 'text-register',
                    // 	canRemove: false,
                    // 	callback: function () {
                    // 		vm.resources.textRegister.defaultValue = this.value;
                    // 		vm.element.internal_config.textRegister = this.value;
                    // 	},
                    // },

                    textLogout: {
                        name: 'textLogout',
                        defaultValue: '',
                        labelDesc: 'text-register',
                        canRemove: false,
                        callback: function () {
                            vm.resources.textLogout.defaultValue = this.value.trim();
                            vm.element.internal_config.textLogout = this.value.trim();
                        },
                    },

                    textStyle: {
                        name: 'textStyle',
                        defaultFamily: '',
                        defaultSize: '',
                        showSizeMobile: true,
                        shitOptions: true,
                        defaultSizeMobile: '',
                        defaultColor: '',
                        defaultAlign: '',
                        defaultWeight: '',
                        defaultStroke: '',
                        defaultStyle: '',
                        labelDesc: 'textStyle',
                        callback: function () {

                            vm.resources.textStyle.defaultFamily = this.family;
                            vm.element.internal_config.textStyle.family = this.family;

                            vm.resources.textStyle.defaultSize = this.size + 'px';
                            vm.element.internal_config.textStyle.size = this.size + 'px';

                            vm.resources.textStyle.defaultSizeMobile = this.sizeMobile + 'px';
                            vm.element.internal_config.textStyle.sizeMobile = this.sizeMobile + 'px';

                            vm.resources.textStyle.defaultColor = this.color;
                            vm.element.internal_config.textStyle.color = this.color;

                            vm.resources.textStyle.defaultAlign = this.align;
                            vm.element.internal_config.textStyle.align = this.align;

                            vm.resources.textStyle.defaultWeight = this.weight;
                            vm.element.internal_config.textStyle.weight = this.weight;

                            vm.resources.textStyle.defaultStyle = this.style;
                            vm.element.internal_config.textStyle.style = this.style;

                            vm.resources.textStyle.defaultStroke = this.stroke;
                            vm.element.internal_config.textStyle.stroke = this.stroke;


                        },
                    },

                    boxShadow: {
                        name: 'boxShadow',
                        defaultValue: '0 0 0 0 black initial',
                        min: '0',
                        max: '50',
                        labelDesc: 'boxShadow',
                        callback: function () {

                            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

                            vm.resources.boxShadow.defaultValue = value;
                            vm.element.internal_config.boxShadow = value;
                        },
                    },

                    border: {
                        name: 'border',
                        defaultValue: '1px solid black',
                        min: '0',
                        max: '50',
                        labelDesc: 'border',
                        callback: function () {
                            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

                            vm.resources.border.defaultValue = value;
                            vm.element.internal_config.border = value;
                        },
                    },

                    borderRadius: {
                        name: 'borderRadius',
                        defaultValue: '0 0 0 0',
                        min: '0',
                        max: '360',
                        labelDesc: 'borderRadius',
                        callback: function () {

                            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

                            vm.resources.borderRadius.defaultValue = value;
                            vm.element.internal_config.borderRadius = value;
                        },
                    },

                    backgroundColor: {
                        name: 'backgroundColor',
                        defaultValue: '#ffffff',
                        labelDesc: 'resource-bg-color',
                        callback: function () {
                            vm.resources.backgroundColor.defaultValue = this.colorValue;
                            vm.element.internal_config.backgroundColor = this.colorValue;
                        },
                    },
                    backgroundColorHover: {
                        name: 'backgroundColorHover',
                        defaultValue: '#ffffff',
                        labelDesc: 'resource-bg-color-hover',
                        callback: function () {
                            vm.resources.backgroundColorHover.defaultValue = this.colorValue;
                            vm.element.internal_config.backgroundColorHover = this.colorValue;
                        },
                    },

                }
            }
        },
        methods: {
            setValuesData(data) {
                this.element = data;
                // console.log('data', data);

                this.resources.textLogin.defaultValue = data.internal_config.textLogin;
                this.resources.textLogout.defaultValue = data.internal_config.textLogout;

                this.resources.border.defaultValue = data.internal_config.border;
                this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
                this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;

                this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
                this.resources.backgroundColorHover.defaultValue = data.internal_config.backgroundColorHover;

                this.resources.textStyle.defaultFamily = data.internal_config.textStyle.family;
                this.resources.textStyle.defaultSize = data.internal_config.textStyle.size;
                this.resources.textStyle.defaultColor = data.internal_config.textStyle.color;
                this.resources.textStyle.defaultAlign = data.internal_config.textStyle.align;
                this.resources.textStyle.defaultWeight = data.internal_config.textStyle.weight;
                this.resources.textStyle.defaultStyle = data.internal_config.textStyle.style;
                this.resources.textStyle.defaultStroke = data.internal_config.textStyle.stroke;
            },
            getValuesData() {
                return this.resources;
            }
        },
    }
</script>
